import { render, staticRenderFns } from "./InsMenuLayout.vue?vue&type=template&id=e4cf873e&scoped=true"
import script from "./InsMenuLayout.vue?vue&type=script&lang=ts"
export * from "./InsMenuLayout.vue?vue&type=script&lang=ts"
import style0 from "./InsMenuLayout.vue?vue&type=style&index=0&id=e4cf873e&prod&lang=less"
import style1 from "./InsMenuLayout.vue?vue&type=style&index=1&id=e4cf873e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4cf873e",
  null
  
)

export default component.exports